// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsProductCardStyles } from "@tps/App/Components/ProductDetails/ProductDetailsProductCard";
import { pdpIconStyle } from "@tps/XDL/PreStyle/select";
import { fontConfig } from "@tps/XDL/PreStyle/typography";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productDetailsProductCardStyles.topSection = {
    css: css`
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            justify-content: flex-start;
            row-gap: 4px;
        }
    `,
};
productDetailsProductCardStyles.bottomSection = {
    css: css``,
};
productDetailsProductCardStyles.country = {
    size: 12,
    css: css`
        line-height: 17px;
    `,
};
productDetailsProductCardStyles.description = {
    variant: "h5",
    forwardAs: "p",
    weight: fontConfig.weight.regular,
    css: css`
        margin-bottom: 0;
        margin-right: 12px;
        > strong {
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};
productDetailsProductCardStyles.descriptionDocumnetsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
    `,
};
productDetailsProductCardStyles.documents = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding-top: 4px;
    `,
};
productDetailsProductCardStyles.documentLink = {
    css: css`
        line-height: 17px;
        align-items: flex-start;
    `,
    typographyProps: {
        weight: fontConfig.weight.bold,
        size: 12,
        css: css`
            line-height: 17px;
        `,
    },
};
productDetailsProductCardStyles.qtyAndPriceWrapper = {
    css: css`
        text-align: right;
        flex-shrink: 0;
        ${xScreen("lte", "md")} {
            text-align: left;
        }
    `,
};
productDetailsProductCardStyles.productPriceStyles = {
    price: {
        priceText: {
            variant: "h5",
            forwardAs: "p",
            weight: fontConfig.weight.bold,
            css: css`
                margin-bottom: 0;
            `,
        },
        errorText: {
            variant: "h5",
            forwardAs: "p",
            weight: fontConfig.weight.bold,
            css: css`
                margin-bottom: 0;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 14,
                lineHeight: "19px",
                css: css`
                    white-space: nowrap;
                `,
            },
        },
    },
};
productDetailsProductCardStyles.descriptionProductNumberWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productDetailsProductCardStyles.productNumber = { size: 12, lineHeight: "17px" };

productDetailsProductCardStyles.productShippingAndActionsStyles = {
    shippingDropDown: pdpIconStyle,
};
